import { Style } from '@glitz/type';
import { thick, tiny, small } from './values';

export function depth(): Style {
  return {
    filter: `drop-shadow(0 ${thick}px ${tiny}px rgba(0, 0, 0, .1)) drop-shadow(0 ${thick}px ${small}px rgba(0, 0, 0, .05))`,
  };
}
